import { Component } from "@angular/core";
import { LoginService } from "./login.service";
import { LoginResponse } from "../../models/auth";
import { Router } from "@angular/router";

@Component({
    templateUrl: "./login.component.html"
})
export class LoginComponent {

    public username: string;
    public password: string;
    public working = false;
    public usernameError = false;
    public passwordError = false;
    public error: any;

    constructor(private loginService: LoginService, private router: Router) { }

    login(): void {
        if (!this.validateLoginForm()) { return; }
        this.working = true;
        this.error = undefined;
        this.loginService.getToken(this.username, this.password).finally(() => this.working = false).subscribe(
            response => {
                // We're probably going to want more properties in the future, for now token is enough
                this.storeToken(response.type, response.token);
                // Change this to where we actually need to go to
                this.router.navigate(["/programs"]);
            },
            error => this.error = error
        );
    }

    storeToken(type: string, token: string) {
        localStorage.setItem("ani-token", token);
    }

    validateLoginForm(): boolean {
        this.username ? this.usernameError = false : this.usernameError = true;
        this.password ? this.passwordError = false : this.passwordError = true;
        if (this.usernameError || this.passwordError) { return false; }
        return true;
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/login/login.component.ts